
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "CancelButton",
  emits: ["cancel"],
  setup(_, { emit }) {
    const { confirmation } = usePlugin();

    const onCancel = () => {
      confirmation.require({
        header: "ยกเลิกเอกสาร",
        message: "กรุณายืนยันเพื่อทำการยกเลิกเอกสาร?",
        acceptLabel: "ยืนยัน ยกเลิกเอกสาร",
        rejectLabel: "ปิด",
        acceptClass: "p-button-danger",
        accept: () => {
          emit("cancel");
        },
      });
    };
    return { onCancel };
  },
});
